// components/monitoring/StatusCard.tsx
import React from 'react';

interface StatusCardProps {
    title: string;
    value: string;
    color: 'green' | 'yellow' | 'red' | 'blue';
}

const StatusCard: React.FC<StatusCardProps> = ({ title, value, color }) => {
    let colorClasses = '';

    switch (color) {
        case 'green':
            colorClasses = 'bg-green-100 dark:bg-green-800 text-green-800 dark:text-green-100';
            break;
        case 'yellow':
            colorClasses = 'bg-yellow-100 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-100';
            break;
        case 'red':
            colorClasses = 'bg-red-100 dark:bg-red-800 text-red-800 dark:text-red-100';
            break;
        case 'blue':
            colorClasses = 'bg-blue-100 dark:bg-blue-800 text-blue-800 dark:text-blue-100';
            break;
    }

    return (
        <div className={`rounded-lg shadow p-4 ${colorClasses}`}>
            <h3 className="text-sm font-medium">{title}</h3>
            <p className="text-3xl font-bold mt-2">{value}</p>
        </div>
    );
};

export default StatusCard;